/**
 * Created by mac on 10/28/20
 */

const VisibilityHandler = function (scroll) {
    this.scroll = scroll;
    this.visibilityCheckList = scroll.innerContent.getChildrenItems ? scroll.innerContent.getChildrenItems() : scroll.innerContent.children;
    this.currentVisibleChildIds = [];

    this.reset();
};

VisibilityHandler.prototype.reset = function () {
    this.currentVisibleChildIds = [];
    for (let i = 0; i < this.visibilityCheckList.length; i++) {
        this.currentVisibleChildIds.push(i);
    }
};

VisibilityHandler.prototype.updateVisibility = function () {
    const visibleIds = this.getVisibleIds();

    let i, child;
    for (i = 0; i < this.currentVisibleChildIds.length; i++) {
        child = this.visibilityCheckList[this.currentVisibleChildIds[i]];
        if (child) {
            child.hideDirty = true;
        }
    }

    for (i = 0; i < visibleIds.length; i++) {
        child = this.visibilityCheckList[visibleIds[i]];
        delete child.hideDirty;
        delete child.beyondScroll;
        child.visible = true;
    }

    for (i = 0; i < this.currentVisibleChildIds.length; i++) {
        child = this.visibilityCheckList[this.currentVisibleChildIds[i]];
        if (child && child.hideDirty) {
            delete child.hideDirty;
            child.visible = false;
            child.beyondScroll = true;
        }
    }

    this.currentVisibleChildIds = visibleIds;
};

VisibilityHandler.prototype.getVisibleIds = function () {
    const ids = [];
    const children = this.visibilityCheckList;

    for (let i = 0; i < children.length; i++) {
        const child = children[i];
        let rect;

        if (child.parent && child.parent !== this.scroll.innerContent) {
            const box = child.getBoundingBox();
            const boxCenter = cc.p(box.x + box.width / 2, box.y + box.height / 2);
            const posInInner = this.scroll.innerContent.convertToNodeSpace(child.parent.convertToWorldSpace(boxCenter));
            rect = cc.rect(posInInner.x, posInInner.y, box.width, box.height);
        } else {
            rect = child;
        }

        if (this.isRectVisible(rect)) {
            ids.push(i);
        }
    }
    return ids;
};

VisibilityHandler.prototype.isRectVisible = function (rect) {
    const zoom = this.scroll.zoom;

    const cx = rect.x - this.scroll.innerContent.width / 2;
    const cy = rect.y - this.scroll.innerContent.height / 2;

    if (-this.scroll.innerContent.x - this.scroll.width / zoom / 2 - rect.width / 2 <= cx && cx <= -this.scroll.innerContent.x + this.scroll.width / zoom / 2 + rect.width / 2
        && -this.scroll.innerContent.y - this.scroll.height / zoom / 2 - rect.height / 2 <= cy && cy <= -this.scroll.innerContent.y + this.scroll.height / zoom / 2 + rect.height / 2) {
        return true;
    }
    return false;
};